'use client';

import { useEffect } from 'react';

const REGISTER_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSe0kosodereCMbj_a0BAEGw8VUViXMV2AIOuWD384LNWawInw/viewform?usp=header';

const NOISE_BG =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 250 250' xmlns='http://www.w3.org/2000/svg'%3E" +
  "%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.88' " +
  "numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E" +
  "%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,800;1,400;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css');

main:has(#webinar-root) { padding-top: 0 !important; }

body:has(#webinar-root) {
  background: #04060E;
  overflow-x: hidden;
  cursor: default;
}

body:has(#webinar-root)::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  opacity: .028;
  background-image: ${NOISE_BG};
}

#webinar-root {
  font-family: 'Pretendard', 'Inter', sans-serif;
  color: #E4F2FF;
}

#webinar-root *, #webinar-root *::before, #webinar-root *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#webinar-root h1,
#webinar-root h2 {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}

#webinar-root p { margin: 0; }

#webinar-root a {
  color: inherit;
  text-decoration: none;
}

#webinar-root hr {
  border: none;
  margin: 0;
}

/* ── CHROME RULE ── */
#webinar-root .chrome-rule {
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #5A6E88 15%, #DDF0FF 42%, #F2F8FF 50%, #DDF0FF 58%, #5A6E88 85%, transparent 100%);
  position: relative;
  z-index: 1;
}

/* ── HEADER ── */
#webinar-root .wbr-header {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 100;
  padding: 18px 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(4, 6, 14, 0.82);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(186,208,232,.08);
}

#webinar-root .logo-wrap {
  display: flex;
  align-items: center;
  gap: 14px;
}

#webinar-root .logo-mark {
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 15px;
  letter-spacing: 4px;
  text-transform: uppercase;
  background: linear-gradient(108deg, #2E3E54 0%, #5A6E88 18%, #BAD0E8 36%, #F2F8FF 50%, #DDF0FF 60%, #8EA4C0 76%, #2E3E54 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

#webinar-root .logo-sep {
  width: 1px;
  height: 20px;
  background: rgba(186,208,232,.2);
}

#webinar-root .logo-firm {
  font-family: 'Pretendard', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #6E9EC0;
  letter-spacing: 0.5px;
}

#webinar-root .header-cta {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #04060E;
  background: linear-gradient(135deg, #1ABCD8, #1098B8);
  padding: 9px 22px;
  border-radius: 6px;
  text-decoration: none;
  letter-spacing: 0.3px;
  transition: opacity .2s;
  display: inline-block;
}
#webinar-root .header-cta:hover { opacity: .85; }

/* ── HERO ── */
#webinar-root .wbr-hero {
  min-height: 100vh;
  background: linear-gradient(148deg, #04060E 0%, #060F22 55%, #073040 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 140px 52px 100px;
  position: relative;
  overflow: hidden;
}

#webinar-root .wbr-hero::after {
  content: '';
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
  height: 600px;
  background: radial-gradient(ellipse, rgba(16,152,184,.10) 0%, transparent 70%);
  pointer-events: none;
}

#webinar-root .hero-eyebrow {
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 8px;
  text-transform: uppercase;
  color: #1ABCD8;
  margin-bottom: 32px;
  opacity: 0;
  animation: wbrFadeUp .8s .1s forwards;
}

#webinar-root .hero-firm-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'Pretendard', sans-serif;
  font-size: 13px;
  color: #6E9EC0;
  border: 1px solid rgba(26,188,216,.2);
  padding: 7px 18px;
  border-radius: 100px;
  margin-bottom: 52px;
  opacity: 0;
  animation: wbrFadeUp .8s .2s forwards;
}

#webinar-root .hero-firm-badge .badge-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  background: #1ABCD8;
  display: inline-block;
  animation: wbrPulse 2s infinite;
  flex-shrink: 0;
}

#webinar-root .hero-title {
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  font-size: clamp(42px, 6vw, 76px);
  line-height: 1.18;
  color: #F2F8FF;
  margin-bottom: 28px;
  letter-spacing: -0.5px;
  max-width: 920px;
  opacity: 0;
  animation: wbrFadeUp .9s .35s forwards;
}

#webinar-root .hero-title .chrome-text {
  background: linear-gradient(108deg, #2E3E54 0%, #5A6E88 18%, #BAD0E8 36%, #F2F8FF 50%, #DDF0FF 60%, #8EA4C0 76%, #2E3E54 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

#webinar-root .hero-sub {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(18px, 2.2vw, 24px);
  font-weight: 300;
  color: #6E9EC0;
  line-height: 1.7;
  max-width: 700px;
  margin-bottom: 56px;
  opacity: 0;
  animation: wbrFadeUp .9s .5s forwards;
}

#webinar-root .hero-meta-row {
  display: flex;
  gap: 40px;
  align-items: center;
  justify-content: center;
  margin-bottom: 52px;
  opacity: 0;
  animation: wbrFadeUp .9s .65s forwards;
  flex-wrap: wrap;
}

#webinar-root .hero-meta-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

#webinar-root .meta-label {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 5px;
  text-transform: uppercase;
  color: #2E5070;
}

#webinar-root .meta-value {
  font-family: 'Playfair Display', serif;
  font-size: clamp(22px, 3vw, 32px);
  font-weight: 700;
  color: #DDF0FF;
}

#webinar-root .meta-sep {
  width: 1px;
  height: 48px;
  background: rgba(186,208,232,.15);
}

#webinar-root .hero-cta-group {
  display: flex;
  gap: 14px;
  opacity: 0;
  animation: wbrFadeUp .9s .8s forwards;
  flex-wrap: wrap;
  justify-content: center;
}

#webinar-root .btn-primary {
  font-family: 'Pretendard', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #04060E;
  background: linear-gradient(135deg, #1ABCD8, #1098B8);
  padding: 16px 36px;
  border-radius: 8px;
  text-decoration: none;
  letter-spacing: 0.5px;
  transition: opacity .2s, transform .2s;
  display: inline-block;
}
#webinar-root .btn-primary:hover { opacity: .88; transform: translateY(-2px); }

#webinar-root .btn-outline {
  font-family: 'Pretendard', sans-serif;
  font-size: 17px;
  font-weight: 500;
  color: #BAD0E8;
  border: 1px solid rgba(186,208,232,.25);
  padding: 16px 36px;
  border-radius: 8px;
  text-decoration: none;
  transition: border-color .2s, color .2s;
  display: inline-block;
}
#webinar-root .btn-outline:hover { border-color: #BAD0E8; color: #F2F8FF; }

#webinar-root .scroll-hint {
  position: absolute;
  bottom: 36px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  opacity: 0;
  animation: wbrFadeIn 1s 1.4s forwards;
}

#webinar-root .scroll-hint .scroll-label {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #2E5070;
}

#webinar-root .scroll-arrow {
  width: 20px;
  height: 32px;
  border: 1px solid rgba(186,208,232,.2);
  border-radius: 10px;
  position: relative;
}
#webinar-root .scroll-arrow::after {
  content: '';
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #1ABCD8;
  animation: wbrScrollDot 1.8s infinite;
}

/* ── SECTIONS COMMON ── */
#webinar-root .sec-wrap {
  max-width: 1100px;
  margin: 0 auto;
}

#webinar-root .sec-eyebrow {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 7px;
  text-transform: uppercase;
  color: #1ABCD8;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
}
#webinar-root .sec-eyebrow::after {
  content: '';
  flex: 1;
  max-width: 60px;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #5A6E88 15%, #DDF0FF 42%, #F2F8FF 50%, #DDF0FF 58%, #5A6E88 85%, transparent 100%);
}

#webinar-root .sec-title {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(32px, 4.5vw, 56px);
  font-weight: 700;
  color: #F2F8FF;
  line-height: 1.25;
  margin-bottom: 64px;
}

/* ── PROBLEM ── */
#webinar-root .wbr-problem {
  background: #060F22;
  padding: 120px 52px;
  position: relative;
  z-index: 1;
}

#webinar-root .problem-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
}

#webinar-root .problem-card {
  background: #0A0E1C;
  padding: 44px 36px;
  position: relative;
  overflow: hidden;
  transition: background .3s;
}
#webinar-root .problem-card:hover { background: #0F1526; }

#webinar-root .problem-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, #5A6E88 15%, #DDF0FF 42%, #F2F8FF 50%, #DDF0FF 58%, #5A6E88 85%, transparent 100%);
  opacity: .5;
}

#webinar-root .problem-region {
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 5px;
  text-transform: uppercase;
  color: #1ABCD8;
  margin-bottom: 20px;
}

#webinar-root .problem-issue {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(20px, 2.5vw, 28px);
  font-weight: 700;
  color: #DDF0FF;
  line-height: 1.35;
  margin-bottom: 16px;
}

#webinar-root .problem-desc {
  font-family: 'Pretendard', sans-serif;
  font-size: 15px;
  color: #6E9EC0;
  line-height: 1.75;
}

/* ── INSIGHT ── */
#webinar-root .wbr-insight {
  background: #070A14;
  padding: 96px 52px;
  position: relative;
  z-index: 1;
  text-align: center;
}

#webinar-root .insight-quote {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(28px, 4vw, 52px);
  font-weight: 700;
  color: #F2F8FF;
  line-height: 1.4;
  max-width: 900px;
  margin: 0 auto 28px;
}

#webinar-root .insight-quote strong {
  background: linear-gradient(108deg, #2E3E54 0%, #5A6E88 18%, #BAD0E8 36%, #F2F8FF 50%, #DDF0FF 60%, #8EA4C0 76%, #2E3E54 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
}

#webinar-root .insight-sub {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(16px, 2vw, 20px);
  color: #6E9EC0;
  font-weight: 300;
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.7;
}

/* ── MARKETS ── */
#webinar-root .wbr-markets {
  background: #070A14;
  padding: 120px 52px;
  position: relative;
  z-index: 1;
}

#webinar-root .markets-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2px;
  margin-top: 64px;
}

#webinar-root .market-card {
  background: #0A0E1C;
  padding: 40px 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: background .3s;
}
#webinar-root .market-card:hover { background: #091A35; }
#webinar-root .market-card::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(135deg, #1ABCD8, #1098B8);
  transform: scaleX(0);
  transition: transform .3s;
}
#webinar-root .market-card:hover::after { transform: scaleX(1); }

#webinar-root .market-flag {
  font-size: 40px;
  margin-bottom: 18px;
  display: block;
}

#webinar-root .market-name {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(18px, 2vw, 22px);
  font-weight: 700;
  color: #DDF0FF;
  margin-bottom: 12px;
}

#webinar-root .market-risk {
  font-family: 'Pretendard', sans-serif;
  font-size: 13px;
  color: #6E9EC0;
  line-height: 1.55;
}

/* ── AGENDA ── */
#webinar-root .wbr-agenda {
  background: #04060E;
  padding: 120px 52px;
  position: relative;
  z-index: 1;
}

#webinar-root .agenda-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

#webinar-root .agenda-item {
  display: grid;
  grid-template-columns: 56px 1fr;
  background: #060F22;
  border-left: 2px solid transparent;
  transition: border-color .3s, background .3s;
  cursor: default;
}
#webinar-root .agenda-item:hover {
  border-left-color: #1098B8;
  background: #091A35;
}

#webinar-root .agenda-num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  font-weight: 700;
  color: #2E5070;
  background: rgba(0,0,0,.15);
  min-height: 96px;
  padding: 24px 0;
  transition: color .3s;
}
#webinar-root .agenda-item:hover .agenda-num { color: #1098B8; }

#webinar-root .agenda-content {
  padding: 28px 36px;
}

#webinar-root .agenda-text {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(18px, 2.2vw, 24px);
  font-weight: 500;
  color: #BAD0E8;
  line-height: 1.5;
}

#webinar-root .agenda-sub {
  font-size: 0.8em;
  opacity: 0.65;
}

/* ── INFO ── */
#webinar-root .wbr-info {
  background: #060F22;
  padding: 120px 52px;
  position: relative;
  z-index: 1;
}

#webinar-root .info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: start;
}

#webinar-root .info-block {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

#webinar-root .info-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 28px;
  border-bottom: 1px solid rgba(186,208,232,.06);
}
#webinar-root .info-row:last-child { border-bottom: none; }

#webinar-root .info-key {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 5px;
  text-transform: uppercase;
  color: #2E5070;
}

#webinar-root .info-val {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(22px, 2.8vw, 34px);
  font-weight: 700;
  color: #DDF0FF;
  line-height: 1.35;
}

#webinar-root .info-val-sub {
  font-family: 'Pretendard', sans-serif;
  font-size: 15px;
  color: #6E9EC0;
  margin-top: 4px;
}

#webinar-root .speakers-block {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

#webinar-root .speakers-label {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 5px;
  text-transform: uppercase;
  color: #2E5070;
  margin-bottom: 8px;
}

#webinar-root .speaker-card {
  background: #0A0E1C;
  border: 1px solid rgba(186,208,232,.07);
  border-top: 2px solid rgba(26,188,216,.25);
  padding: 28px 32px;
}

#webinar-root .speaker-role {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #1ABCD8;
  margin-bottom: 10px;
}

#webinar-root .speaker-name {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(22px, 2.5vw, 30px);
  font-weight: 700;
  color: #F2F8FF;
  margin-bottom: 6px;
}

#webinar-root .speaker-title {
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  color: #6E9EC0;
}

/* ── CTA ── */
#webinar-root .wbr-cta {
  background: #04060E;
  padding: 140px 52px;
  position: relative;
  z-index: 1;
  text-align: center;
}

#webinar-root .cta-eyebrow {
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 8px;
  text-transform: uppercase;
  color: #1ABCD8;
  margin-bottom: 32px;
}

#webinar-root .cta-title {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(36px, 5vw, 68px);
  font-weight: 700;
  color: #F2F8FF;
  line-height: 1.2;
  max-width: 840px;
  margin: 0 auto 24px;
}

#webinar-root .cta-desc {
  font-family: 'Pretendard', sans-serif;
  font-size: clamp(15px, 1.8vw, 18px);
  color: #6E9EC0;
  font-weight: 300;
  max-width: 560px;
  margin: 0 auto 52px;
  line-height: 1.75;
}

#webinar-root .cta-btn {
  display: inline-block;
  font-family: 'Pretendard', sans-serif;
  font-size: 19px;
  font-weight: 700;
  color: #04060E;
  background: linear-gradient(135deg, #1ABCD8, #1098B8);
  padding: 20px 52px;
  border-radius: 8px;
  text-decoration: none;
  margin-bottom: 24px;
  transition: opacity .2s, transform .2s;
}
#webinar-root .cta-btn:hover { opacity: .88; transform: translateY(-2px); }

#webinar-root .cta-note {
  font-family: 'Pretendard', sans-serif;
  font-size: 13px;
  color: #2E5070;
}

/* ── LAWKIT STRIP ── */
#webinar-root .wbr-lawkit {
  background: #060F22;
  padding: 72px 52px;
  position: relative;
  z-index: 1;
}

#webinar-root .lawkit-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
}

#webinar-root .lawkit-left {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#webinar-root .lawkit-badge {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 5px;
  text-transform: uppercase;
  color: #1ABCD8;
}

#webinar-root .lawkit-name {
  font-family: 'Inter', sans-serif;
  font-size: clamp(28px, 3.5vw, 42px);
  font-weight: 800;
  letter-spacing: 4px;
  background: linear-gradient(108deg, #2E3E54 0%, #5A6E88 18%, #BAD0E8 36%, #F2F8FF 50%, #DDF0FF 60%, #8EA4C0 76%, #2E3E54 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

#webinar-root .lawkit-desc {
  font-family: 'Pretendard', sans-serif;
  font-size: 15px;
  color: #6E9EC0;
  max-width: 440px;
  line-height: 1.7;
}

#webinar-root .lawkit-link {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1ABCD8;
  text-decoration: none;
  border: 1px solid rgba(26,188,216,.25);
  padding: 13px 28px;
  border-radius: 6px;
  white-space: nowrap;
  transition: background .2s, border-color .2s;
  display: inline-block;
}
#webinar-root .lawkit-link:hover {
  background: rgba(26,188,216,.08);
  border-color: #1ABCD8;
}

/* ── FOOTER ── */
#webinar-root .wbr-footer {
  background: #04060E;
  padding: 56px 52px;
  text-align: center;
  position: relative;
  z-index: 1;
}

#webinar-root .footer-logo {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 6px;
  text-transform: uppercase;
  background: linear-gradient(108deg, #2E3E54 0%, #5A6E88 18%, #BAD0E8 36%, #F2F8FF 50%, #DDF0FF 60%, #8EA4C0 76%, #2E3E54 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 14px;
}

#webinar-root .footer-firm {
  font-family: 'Pretendard', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #6E9EC0;
  margin-bottom: 8px;
}

#webinar-root .footer-sub {
  font-family: 'Pretendard', sans-serif;
  font-size: 13px;
  color: #2E5070;
}

/* ── SCROLL REVEAL ── */
#webinar-root .reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity .8s ease, transform .8s ease;
}
#webinar-root .reveal.visible {
  opacity: 1;
  transform: translateY(0);
}

/* ── ANIMATIONS ── */
@keyframes wbrFadeUp {
  from { opacity: 0; transform: translateY(28px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes wbrFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
@keyframes wbrPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: .5; transform: scale(.8); }
}
@keyframes wbrScrollDot {
  0%   { top: 6px; opacity: 1; }
  80%  { top: 18px; opacity: 0; }
  100% { top: 6px; opacity: 0; }
}

/* ── RESPONSIVE ── */
@media (max-width: 900px) {
  #webinar-root .wbr-header { padding: 16px 24px; }
  #webinar-root .wbr-hero,
  #webinar-root .wbr-problem,
  #webinar-root .wbr-insight,
  #webinar-root .wbr-markets,
  #webinar-root .wbr-agenda,
  #webinar-root .wbr-info,
  #webinar-root .wbr-cta,
  #webinar-root .wbr-lawkit,
  #webinar-root .wbr-footer {
    padding-left: 24px;
    padding-right: 24px;
  }
  #webinar-root .problem-grid { grid-template-columns: 1fr; }
  #webinar-root .info-grid { grid-template-columns: 1fr; }
  #webinar-root .markets-grid { grid-template-columns: repeat(3, 1fr); }
  #webinar-root .logo-firm { display: none; }
}

@media (max-width: 600px) {
  #webinar-root .markets-grid { grid-template-columns: repeat(2, 1fr); }
  #webinar-root .meta-sep { display: none; }
}
`;

export default function WebinarContent() {
  useEffect(() => {
    const reveals = document.querySelectorAll('#webinar-root .reveal');
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add('visible'), 80);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 },
    );
    reveals.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: css }} />
      <div id="webinar-root">
        {/* HEADER */}
        <div className="wbr-header">
          <div className="logo-wrap">
            <span className="logo-mark">LawKit</span>
            <div className="logo-sep" />
            <span className="logo-firm">법무법인 오킴스</span>
          </div>
          <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" className="header-cta">
            참가 신청하기
          </a>
        </div>

        {/* HERO */}
        <section className="wbr-hero">
          <div className="hero-eyebrow">Webinar — OhKims Law Firm</div>
          <div className="hero-firm-badge">
            <span className="badge-dot" />
            법무법인 오킴스 초청 웨비나
          </div>
          <h1 className="hero-title">
            글로벌 거래,
            <br />
            <span className="chrome-text">같은 계약</span>이<br />
            다르게 무너지는 이유
          </h1>
          <p className="hero-sub">
            계약서가 아닌, 법률 환경의 차이가
            <br />
            기업의 리스크를 결정합니다.
          </p>
          <div className="hero-meta-row">
            <div className="hero-meta-item">
              <span className="meta-label">Date</span>
              <span className="meta-value">4월 16일 (목)</span>
            </div>
            <div className="meta-sep" />
            <div className="hero-meta-item">
              <span className="meta-label">Time</span>
              <span className="meta-value">오후 3:00 – 4:00</span>
            </div>
            <div className="meta-sep" />
            <div className="hero-meta-item">
              <span className="meta-label">Platform</span>
              <span className="meta-value">Zoom</span>
            </div>
            <div className="meta-sep" />
            <div className="hero-meta-item">
              <span className="meta-label">Year</span>
              <span className="meta-value">2026</span>
            </div>
          </div>
          <div className="hero-cta-group">
            <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" className="btn-primary">
              지금 신청하기
            </a>
            <a href="#agenda" className="btn-outline">
              웨비나 내용 보기
            </a>
          </div>
          <div className="scroll-hint">
            <span className="scroll-label">Scroll</span>
            <div className="scroll-arrow" />
          </div>
        </section>

        <div className="chrome-rule" />

        {/* PROBLEM */}
        <section className="wbr-problem">
          <div className="sec-wrap">
            <div className="sec-eyebrow reveal">The Problem</div>
            <h2 className="sec-title reveal">
              계약서는 완벽했습니다.
              <br />
              그런데 왜 문제가 발생할까요?
            </h2>
            <div className="problem-grid">
              {[
                { region: 'EU', issue: '규제 장벽으로\n납품이 중단됩니다', desc: '계약은 완벽했지만, 현지 규정이 이행 자체를 가로막습니다.' },
                { region: '미국', issue: '예기치 못한 소송과\n제재가 불거집니다', desc: '미국 시장의 법적 환경은 한국과 근본적으로 다르게 작동합니다.' },
                { region: '중국 · 동남아', issue: '판결을 받아도\n집행 자체가 안 됩니다', desc: '승소해도 현지 집행력이 없다면 계약은 종이 한 장에 불과합니다.' },
              ].map(card => (
                <div key={card.region} className="problem-card reveal">
                  <div className="problem-region">{card.region}</div>
                  <div className="problem-issue">
                    {card.issue.split('\n').map((line, i) => (
                      <span key={i}>
                        {line}
                        {i === 0 && <br />}
                      </span>
                    ))}
                  </div>
                  <div className="problem-desc">{card.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="chrome-rule" />

        {/* INSIGHT */}
        <section className="wbr-insight">
          <div className="reveal">
            <div className="insight-quote">
              문제는 계약서가 아닙니다.
              <br />
              <strong>법률 환경이 다릅니다.</strong>
            </div>
            <p className="insight-sub">
              계약이 실제로 작동하는 법적 환경에 따라,
              <br />
              기업이 직면하는 리스크의 성격과 규모는 전혀 달라집니다.
            </p>
          </div>
        </section>

        <div className="chrome-rule" />

        {/* MARKETS */}
        <section className="wbr-markets">
          <div className="sec-wrap">
            <div className="sec-eyebrow reveal">Coverage</div>
            <h2 className="sec-title reveal">
              시장별 계약 리스크의
              <br />
              구조적 차이
            </h2>
            <div className="markets-grid">
              {[
                { flag: '🇪🇺', name: 'EU', risk: '규제·컴플라이언스 리스크' },
                { flag: '🇺🇸', name: '미국', risk: '소송·제재·수출통제' },
                { flag: '🇨🇳', name: '중국', risk: '집행력·현지법 리스크' },
                { flag: '🌏', name: '동남아', risk: '판결 집행·정치 리스크' },
                { flag: '🇯🇵', name: '일본', risk: '관행·분쟁해결 구조' },
                { flag: '🌍', name: '중동', risk: '이슬람법·계약 구조' },
              ].map(m => (
                <div key={m.name} className="market-card reveal">
                  <span className="market-flag">{m.flag}</span>
                  <div className="market-name">{m.name}</div>
                  <div className="market-risk">{m.risk}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="chrome-rule" />

        {/* AGENDA */}
        <section className="wbr-agenda" id="agenda">
          <div className="sec-wrap">
            <div className="sec-eyebrow reveal">Agenda</div>
            <h2 className="sec-title reveal">
              이번 웨비나에서
              <br />
              다루는 내용
            </h2>
            <div className="agenda-list">
              {[
                { num: '01', title: '시장별 계약 리스크의 구조적 차이', sub: 'EU · 미국 · 중국 · 동남아 · 일본 · 중동, 각 법제가 만들어내는 리스크의 본질적 차이를 비교합니다' },
                { num: '02', title: '동일한 계약, 다른 결과', sub: '한국 기업의 실제 사례를 통해, 같은 계약서가 시장에 따라 전혀 다른 결과를 낳는 이유를 살펴봅니다' },
                { num: '03', title: '계약 단계에서의 리스크 대응 전략', sub: '기업이 계약 체결 이전에 반드시 갖춰야 할 사전 대응 전략을 구체적으로 살펴봅니다' },
                { num: '04', title: '국제중재를 통한 분쟁 해결', sub: '분쟁으로 번질 경우, 국제중재제도를 실무적으로 활용하는 방법과 접근 방안을 짚어드립니다' },
              ].map(item => (
                <div key={item.num} className="agenda-item reveal">
                  <div className="agenda-num">{item.num}</div>
                  <div className="agenda-content">
                    <div className="agenda-text">
                      {item.title}
                      <br />
                      <span className="agenda-sub">{item.sub}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="chrome-rule" />

        {/* INFO */}
        <section className="wbr-info">
          <div className="sec-wrap">
            <div className="sec-eyebrow reveal">Webinar Details</div>
            <h2 className="sec-title reveal">웨비나 안내</h2>
            <div className="info-grid">
              <div className="info-block reveal">
                <div className="info-row">
                  <div className="info-key">일시</div>
                  <div className="info-val">
                    2026년 4월 16일 (목)
                    <br />
                    오후 3:00 – 4:00
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-key">방식</div>
                  <div className="info-val">온라인 (Zoom)</div>
                  <div className="info-val-sub">참가 링크는 신청 완료 후 별도 발송</div>
                </div>
                <div className="info-row">
                  <div className="info-key">대상</div>
                  <div className="info-val">
                    글로벌 거래가 있는
                    <br />
                    스타트업·중소기업
                  </div>
                  <div className="info-val-sub">계약 체결 전 꼭 알아두어야 할 내용</div>
                </div>
              </div>
              <div className="speakers-block reveal">
                <div className="speakers-label">연사 소개</div>
                <div className="speaker-card">
                  <div className="speaker-role">Speaker</div>
                  <div className="speaker-name">이상엽 변호사</div>
                  <div className="speaker-title">법무법인 오킴스</div>
                </div>
                <div className="speaker-card">
                  <div className="speaker-role">Moderator</div>
                  <div className="speaker-name">김용범 대표변호사</div>
                  <div className="speaker-title">법무법인 오킴스</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="chrome-rule" />

        {/* CTA */}
        <section className="wbr-cta">
          <div className="reveal">
            <div className="cta-eyebrow">Register Now</div>
            <h2 className="cta-title">
              글로벌 거래를 하는 기업이라면
              <br />
              지금 바로 신청하세요.
            </h2>
            <p className="cta-desc">
              계약 체결 이전에 반드시 파악해 두어야 할 핵심 내용들을
              <br />
              한 시간으로 압축해 드립니다.
              <br />
              참가 링크는 신청 완료 후 별도 안내됩니다.
            </p>
            <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" className="cta-btn">
              사전 신청하기 →
            </a>
            <div className="cta-note">문의 사항은 언제든지 편하게 연락 주시기 바랍니다</div>
          </div>
        </section>

        <div className="chrome-rule" />

        {/* LAWKIT */}
        <section className="wbr-lawkit">
          <div className="lawkit-inner">
            <div className="lawkit-left reveal">
              <div className="lawkit-badge">Legal Tech Service</div>
              <div className="lawkit-name">LAWKIT</div>
              <div className="lawkit-desc">법무법인 오킴스의 법률 서비스 플랫폼으로, 글로벌 거래의 법적 리스크를 더 빠르게 파악하세요.</div>
            </div>
            <a href="https://lawkit.kr" target="_blank" rel="noopener noreferrer" className="lawkit-link reveal">
              lawkit.kr →
            </a>
          </div>
        </section>

        <div className="chrome-rule" />

        {/* FOOTER */}
        <footer className="wbr-footer">
          <div className="footer-logo">OhKims Law Firm</div>
          <div className="footer-firm">법무법인 오킴스</div>
          <div className="footer-sub">궁금한 사항은 언제든지 문의 주시기 바랍니다.</div>
        </footer>
      </div>
    </>
  );
}
